import { Radio, RadioGroup } from '@headlessui/react';
import { clstx } from '@payaca/utilities/cvaMerge';
import { FC, useContext } from 'react';
import { FieldContext } from '../Field/Context';

export type ColourSwatchInputProps = {
  colors: readonly string[];
  value?: string;
  onChange: (hex: string) => void;
  className?: string;
};

const ColourSwatchInput: FC<ColourSwatchInputProps> = ({
  colors,
  value,
  onChange,
  className,
}) => {
  const { name } = useContext(FieldContext);

  return (
    <RadioGroup
      value={value?.toLowerCase()}
      onChange={onChange}
      name={name}
      className={clstx('flex flex-wrap gap-2.5', className)}
    >
      {colors.map((color) => (
        <Radio
          key={color}
          value={color.toLowerCase()}
          className="size-7 cursor-pointer rounded-md ring-offset-2 ring-offset-white focus:outline-none data-[checked]:ring-2 data-[checked]:ring-blue-500 data-[focus]:ring-2 data-[focus]:ring-blue-500 shadow-[inset_0_0_0_1px_rgba(0,0,0,0.1)]"
          style={{ backgroundColor: color }}
        >
          <span className="sr-only">{color}</span>
        </Radio>
      ))}
    </RadioGroup>
  );
};

export default ColourSwatchInput;
